'use strict';

var meusChamadosMdl = angular.module('meusChamadosMdl', []);
meusChamadosMdl.config(meusChamadosConfig).run(['$templateCache', function($templateCache){
    $templateCache.put('meus-chamados/_lista-visao-alternativa01.html', require('./_lista-visao-alternativa01.html'))
    $templateCache.put('meus-chamados/_lista-visao-default.html', require('./_lista-visao-default.html'))
    $templateCache.put('meus-chamados/_paginacao.html', require('./_paginacao.html'))
}]);
meusChamadosConfig.$inject = ['$stateProvider'];

function meusChamadosConfig($stateProvider) {

    $stateProvider

    .state('app.meus-chamados', {
        url: "/meus-chamados",
        controller: 'meusChamadosCtrl',
        controllerAs: '$ctrl',
        template: require("./meus-chamados-template.html"),
        data: {
            autorizacao: true,
            redirecionarPara: 'autenticacao.login'
        }
    });
}



// WEBPACK FOOTER //
// ./src/modules/meus-chamados/meus-chamados-config.js